// import Amazon from "./Assets/Amazon.png"
const projectsarr=[
{
  id:"1",
  category:"DSA",
  image:"./images/Leetcode.jpg",
  alt:"Leetcode",
  date:"none",
  tech:"none",
  text:"Lorem ipsum, dolor sit amet consectetur adipisicing elit. Distinctio, ratione.", 
  link:"https://leetcode.com/hardikchopra70/" 
},
{
  id:"2",
  category:"Web Development",
  image:"./Amazon.png",
  alt:"amazon clone",
  date:"none",
  tech:"Basic html css and javascript",
  text:"Lorem ipsum, dolor sit amet consectetur adipisicing elit. Distinctio, ratione.",
  link:"deploying soon"  
},








];
export const myexperience=[
  {
    year:"Duration: Ongoing" ,
    title:"Personal Projects" ,
    institue:"web designs",
    desc:"Implemented responsive design principles, ensuring a seamless user experience across different device Utilized HTML, CSS, and JavaScript to create interactive and visually appealing web interfaces."
  },
  {
    year:"Duration: Ongoing" ,
    title:"Collaborative Learning " ,
    institue:"Events/hackathon",
    desc:"Collaborated with fellow learners on group projects, fostering teamwork and effective communication within a development environment.Actively engaged in coding forums or online communities to exchange knowledge  and seek guidance "
  },
  {
    year:"Duration: Ongoing" ,
    title:"Volunter projects" ,
    institue:"lorem",
    desc:"Lorem ipsum, dolor sit amet consectetur adipisicing elit. Explicabo, labore autem. Deserunt, aspernatur voluptatibus quibusdam excepturi quisquam quos obcaecati? Aliquid nobis minima modi reprehenderit atque voluptas laudantium repellendus quasi dolores a, vero quae que."
  },

];
export const myeducation=[
  {
    year:"2004-2019" ,
    title:"Secondary school" ,
    institue:"Sacred heart Convent school",
    desc:"Lorem ipsum, dolor sit amet consectetur adipisicing elit. Explicabo, labore autem. Deserunt, aspernatur voluptatibus quibusdam excepturi quisquam quos obcaecati? Aliquid nobis minima loremaai i Lorem ipsum dolor sit amet. "
    
  },
  {
    year:"2020-2022" ,
    title:"Senior Secondary school " ,
    institue:"Kundan vidhya mandir",
    desc:"Lorem ipsum, dolor sit amet consectetur adipisicing elit. Explicabo, labore autem. Deserunt, aspernatur voluptatibus quibusdam excepturi quisquam quos obcaecati? Aliquid nobis minima modi reprrnatur sit illum saepe tempora eaque."
  },
  {
    year:"2022-Current" ,
    title:"BE- ComputerScience" ,
    institue:"Chandigarh University",
    desc:"Lorem ipsum, dolor sit amet consectetur adipisicing elit. Explicabo, labore autem. Deserunt, aspernatur voluptatibus quibusdam excepturi quisquam quos obcaecati? Aliquid nobis minima modi reprernatur sit illum saepe tempora eaque."
  },

]
export default projectsarr